const faqs = [
  {
    q: '97影院需要注册或付费吗？',
    a: '完全不需要。97影院所有电影资源均免费在线观看，无需注册账号，无需支付任何费用。打开网站即可畅享高清电影，没有任何隐藏收费。',
  },
  {
    q: '电影画质怎么样，会卡顿吗？',
    a: '我们提供高清蓝光画质片源，并采用先进的CDN分发技术，确保流畅播放不卡顿。建议使用高速网络环境下观看以获得最佳观影体验。',
  },
  {
    q: '支持哪些设备观看？',
    a: '97影院完美适配电脑、平板和手机浏览器。无需下载安装任何软件，浏览器打开即可观看。同时支持投屏到大屏电视，享受家庭影院体验。',
  },
  {
    q: '电影资源多久更新一次？',
    a: '片库每日更新，新片上映后第一时间上线。热门大片通常在院线下映后1-2个月内即可在线观看。我们也会持续补充经典老片资源。',
  },
  {
    q: '可以下载电影离线观看吗？',
    a: '97影院为在线流媒体播放平台，暂不提供下载功能。但您可以在任何有网络的环境下随时访问观看，移动数据流量消耗与主流视频平台相当。',
  },
  {
    q: '遇到播放问题或资源失效怎么办？',
    a: '如果您遇到任何播放问题或发现资源失效，可以通过页面上的联系方式向我们反馈。我们会在24小时内处理并回复，确保观影体验不受影响。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          关于97影院的常见疑问，这里都有解答
        </p>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((item, i) => (
            <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm font-semibold text-foreground-800 pr-8">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-open:rotate-45 transition-transform duration-300">
                  <i className="ri-add-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}